const TRUSTED_HOSTS = new Set([
  'eldrick.com',
  'www.eldrick.com',
  'lab.eldrick.com',
  'api.eldrick.com',
]);

const REFERENCE_ID = /^[A-Za-z0-9_-]{1,128}$/;
const HANDOFF_TOKEN = /^api_[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

/** Return a Lab pathname for a pasted Core/Lab fitting ID or share URL. */
export function parseFittingReference(value: string): string | null {
  const raw = value.trim();
  if (!raw) return null;
  if (HANDOFF_TOKEN.test(raw)) return `/handoff/${raw}`;
  if (REFERENCE_ID.test(raw)) return `/${encodeURIComponent(raw)}`;

  let path = raw;
  try {
    const candidate = /^https?:\/\//i.test(raw) ? new URL(raw) : new URL(`https://${raw}`);
    if (!TRUSTED_HOSTS.has(candidate.hostname.toLowerCase())) return null;
    path = candidate.pathname;
  } catch {
    // Treat non-URL input as a fitting ID below.
  }

  const segments = path.split('/').filter(Boolean).map(segment => {
    try { return decodeURIComponent(segment); } catch { return ''; }
  });
  if (segments[0]?.toLowerCase() === 'handoff' && HANDOFF_TOKEN.test(segments[1] ?? '')) {
    return `/handoff/${segments[1]}`;
  }
  if (segments[0]?.toLowerCase() === 'results' && REFERENCE_ID.test(segments[1] ?? '')) {
    return `/${encodeURIComponent(segments[1])}`;
  }
  if (segments.length === 1 && REFERENCE_ID.test(segments[0]) &&
      !['results', 'handoff'].includes(segments[0].toLowerCase())) {
    return `/${encodeURIComponent(segments[0])}`;
  }
  return null;
}
